import { getSelectTagClassName } from './courseMappingCellFormatters';

interface CourseMappingSelectTagProps {
  label: string;
  columnKey: string;
}

const CourseMappingSelectTag = ({ label, columnKey }: CourseMappingSelectTagProps) => (
  <span className="course-mapping-select-tag-wrapper">
    <span className={`course-mapping-select-tag ${getSelectTagClassName(columnKey, label)}`}>{label}</span>
  </span>
);

export default CourseMappingSelectTag;
